export default "__VITE_ASSET__CaX$CtfX__"